export default __webpack_public_path__ + "static/media/D9C99ED9-04.485bbb65.png";